export default {
    0: {
        "name": "en cours",
        "color": "blue"
    },
    1: {
        "name": "OK",
        "color": "green"
    },
    2: {
        "name": "x block CODA rejetés",
        "color": "orange"
    },
    3: {
        "name": "Fichier rejeté",
        "color": "red"
    },
    4: {
        "name": "x enregistrement rejetés",
        "color": "orange"
    },
    5: {
        "name": "x enregistrement rejetés",
        "color": "orange"
    },
    6: {
        "name": "x enregistrement rejetés",
        "color": "orange"
    },
    7: {
        "name": "x enregistrement rejetés",
        "color": "orange"
    },
    8: {
        "name": "x enregistrement rejetés",
        "color": "orange"
    },
    9: {
        "name": "x enregistrement rejetés",
        "color": "orange"
    },
    10: {
        "name": "Attention facture déjà existante",
        "color": "orange"
    },
    11: {
        "name": "Attention magasin inconnu",
        "color": "orange"
    },
    12: {
        "name": "Bloc FR en erreur",
        "color": "orange"
    },
    13: {
        "name": "Impossible d'évaluer le type de flux",
        "color": "orange"
    },
    14: {
        "name": "Nom de fichier erroné",
        "color": "orange"
    }
}


// WEBPACK FOOTER //
// ./src/enums/JobStatus.js